import S1 from './Step1'
import S2 from './Step2'
import S3 from './Step3'
import S4 from './Step4'

const steps = [S1, S2, S3, S4]

export default steps
